import { ThemeOptions, createTheme } from '@mui/material/styles';
import { ThemeModeValue } from 'src/components/settings/types';
import customShadows from './customShadows';
import ComponentsOverrides from './overrides';
import palette from './palette';
import shadows from './shadows';
import typography from './typography';

declare module '@mui/material/styles' {
  interface Theme {
    themeName: ThemeModeValue;
  }
}

export const createThemeConfig = (themeMode: ThemeModeValue) => {
  const options: ThemeOptions = {
    palette: palette(themeMode),
    typography,
    shape: { borderRadius: 8 },
    direction: 'ltr',
    shadows: shadows(themeMode),
    customShadows: customShadows(themeMode) as any,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1920,
      },
    },
  };

  const theme = createTheme(options);
  (theme as any).themeName = themeMode;
  theme.components = ComponentsOverrides(theme);

  return theme;
};
